var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAddFolder = function SvgAddFolder(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m4 4c-.55228 0-1 .44772-1 1v4 1 9c0 .5523.44772 1 1 1h16c.5523 0 1-.4477 1-1v-10c0-.55228-.4477-1-1-1h-7.5l-3.70711-3.70711c-.18753-.18753-.44189-.29289-.7071-.29289zm7 1h9v2h-7zm.2498 13v-3.25h-3.25003v-1.5h3.25003v-3.25002h1.5v3.25002h3.25v1.5h-3.25v3.25z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAddFolder);
export default ForwardRef;